import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';

import objectToFormData from '../../utils/objectToFormData';

import Signals from '../../signals/Signals';
import AbstractCommand from '../AbstractCommand';
import {AutocompleteTypes} from '../../data/AutocompleteSearchObject';

import incomeUpdate from '../../requests/incomeUpdate';
import incomeFileDelete from '../../requests/incomeFileDelete';

/**
 *
 */
export default class UpdateIncomeCommand extends AbstractCommand {

	/**

	 */
	constructor(applicationStore, incomeModel, file = null) {
		super();

		this.applicationStore = applicationStore;
		this.incomeStore = this.applicationStore.incomeStore;
		this.autocompleteStore = this.applicationStore.autocompleteStore;

		this.incomeModel = incomeModel;
		this.file = file;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {

		const ignoreFields = [];

		// Create FormData
		const formData = objectToFormData(this.incomeModel, true, ignoreFields);

		// Add file
		if (this.file) {
			formData.append('file', this.file);
		}

		// Empty file
		if(!this.incomeModel.fileName) {
			formData.append('fileName', null);
		}

		const promises = [];

		// Update Income
		promises.push(
			incomeUpdate(this.incomeModel.id, formData).then((response) => {

				//
				if (!this.incomeModel.fileName) {
					response.data.fileName = null;
				}

				//
				const model = this.incomeStore.updateIncome(response.data);
				this.autocompleteStore.update(model, AutocompleteTypes.TYPE_INVOICES);
				Signals.ShowMessageDialog.dispatch((<FormattedHTMLMessage id="income.edited.message" values={{invoiceId:model.invoiceNr}}/>));

			})
		);

		// Remove file (needs to happen after update)
		if(!this.incomeModel.fileName) {
			promises.push(incomeFileDelete(this.incomeModel.id));
		}

		//
		Promise.all(promises).then((response) => {
			if (success) {
				success(response);
			}
		}).catch((err) => {
			if (error) {
				error(err);
			}
		});
	}
}
